import type { DpsMiniAppBackendPeriodDto } from "@gameApp/api/types/DpsMiniAppBackend";
import type { MiniGameOrderTimeframe } from "@gameComponents/MiniGame/types";

export const MINI_GAME_ORDER_TYPE_LABELS: Record<
  DpsMiniAppBackendPeriodDto["hours"],
  string
> = {
  "1": "1 hour",
  "4": "4 hours",
  "24": "24 hours",
};

export const MINI_GAME_ORDER_TYPE_LABELS_SHORT: Record<
  DpsMiniAppBackendPeriodDto["hours"],
  MiniGameOrderTimeframe
> = {
  "1": "1H",
  "4": "4H",
  "24": "24H",
};

export const MINI_GAME_ORDER_DIRECTION_LABELS = {
  LONG: "LONG",
  SHORT: "SHORT",
};

export const MINI_GAME_CHART_TIMEFRAMES = [
  "4H",
  "12H",
  "24H",
  "7D",
  "1M",
  "3M",
  "1Y",
  "YTD",
] as const;

export const MINI_GAME_CHART_TIMEFRAMES_API_MAP = {
  "4H": "4H",
  "12H": "12H",
  "24H": "1D",
  "7D": "1W",
  "1M": "1M",
  "3M": "3M",
  "1Y": "1Y",
  YTD: "YTD",
};

export const MINI_GAME_CHART_TIMEFRAME_STORAGE_KEY_PREFIX =
  "miniGameTimeframe-";

export const MINI_GAME_CHART_TIMEFRAME_DEFAULTS = {
  1: "4H",
  4: "12H",
  24: "7D",
};

export const MINI_GAME_CHART_GAP_BETWEEN_CHART_AND_Y_TICKS = 8;

export const MINI_GAME_CHART_SAFE_AREA_TOP = 3;
